import { ReactNode } from 'react'
import '../../sass/landing/MockupChrome.scss'

interface MockupChromeProps {
  icon: ReactNode
  address: string
}

const MockupChrome = ({ icon, address }: MockupChromeProps) => (
  <div className='mockup-chrome' aria-hidden='true'>
    <span className='mockup-chrome__dot mockup-chrome__dot--red' />
    <span className='mockup-chrome__dot mockup-chrome__dot--yellow' />
    <span className='mockup-chrome__dot mockup-chrome__dot--green' />
    <div className='mockup-chrome__address'>
      <span className='mockup-chrome__address-icon'>{icon}</span>
      <span>{address}</span>
    </div>
  </div>
)

export default MockupChrome
